module.exports = __webpack_public_path__ + "static/media/emoticon-emotion-expression-face-shock-svgrepo-com.cbf92580.svg";